module.exports = __webpack_public_path__ + "static/media/test-results.9d6c489a.svg";